const getIsExistingFirebaseUserFromLocalStorage = () => {
  const isExistingFirebaseUser = JSON.parse(localStorage.getItem('anova_is_existing_firebase_user'))

  return isExistingFirebaseUser
}

export default getIsExistingFirebaseUserFromLocalStorage
